import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-app',
  template: `
    <app-sidenav></app-sidenav>
  `,
  styles: [
  ]
})
export class MainAppComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
